import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel
} from '@mui/material'
import { useField } from 'formik'
import { CommonInputProps, CommonLabelProps, StyledTranslationOrText } from '.'

export type CheckboxProps = Omit<MuiCheckboxProps, 'checked' | 'secondary'> &
  Required<Pick<MuiCheckboxProps, 'checked'>> &
  CommonLabelProps &
  Pick<CommonInputProps, 'fontSize'>

export const Checkbox = ({
  fontSize,
  label,
  labelTranslationId,
  ...checkboxProps
}: CheckboxProps) => {
  const checkbox = <MuiCheckbox {...checkboxProps} color="secondary" />

  return (
    <>
      {label || labelTranslationId ? (
        <FormControlLabel
          control={checkbox}
          label={
            <StyledTranslationOrText
              text={label}
              translationId={labelTranslationId}
              typographyProps={{ fontSize }}
            />
          }
        />
      ) : (
        checkbox
      )}
    </>
  )
}

export type FormikCheckboxProps = Required<Pick<CheckboxProps, 'name'>> &
  Omit<CheckboxProps, 'checked' | 'name'>

export const FormikCheckbox = ({ name, ...rest }: FormikCheckboxProps) => {
  const [field] = useField(name)
  return <Checkbox {...field} {...rest} checked={field.value} />
}
